module.exports = __webpack_public_path__ + "img/ovld-logo.c90f665a.svg";